export default __webpack_public_path__ + "static/media/stuff.faf83c88.svg";